import { Skeleton, Text } from "@chakra-ui/react";
import { Select, SingleValue } from "chakra-react-select";
import { FormikProps } from "formik";
import { match } from "ts-pattern";
import { useOptions } from "../../../hooks/useOptions";
import { DashboardViewFormValues } from "../../../types/dashboardForm";
import { ProjectID } from "../../../types/project";
import { useAnalytes } from "../../../services/projectService";
import { useEffect, useMemo } from "react";
import { chakraStyles } from "../../../theme";

export function SelectAnalyte({
  formik,
  project,
  sites,
  startDate,
  endDate,
}: {
  formik: FormikProps<DashboardViewFormValues>;
  project: ProjectID;
  sites: string[];
  startDate: Date;
  endDate: Date;
}) {
  const query = useAnalytes(project, sites, startDate, endDate, true);
  const options = useOptions(query);
  const value = useMemo(
    () => options.find((x: any) => x.value === formik.values.analyte),
    [options, formik.values.analyte],
  );

  useEffect(() => {
    if (
      formik.values.analyte != null &&
      options.length > 0 &&
      !options.find((x: any) => x.value === formik.values.analyte)
    ) {
      formik.setFieldValue("analyte", null);
    }
  }, [formik, options]);

  return match(query)
    .with({ isLoading: true }, () => (
      <Skeleton>
        <Select size="md" />
      </Skeleton>
    ))
    .with({ isError: true }, () => <Text color="red">Error loading analytes</Text>)
    .otherwise(() => (
      <Select
        size="md"
        placeholder="Select Analytes"
        options={options}
        onChange={(x: SingleValue<{ value: string }>) => formik.setFieldValue("analyte", x?.value)}
        value={value}
        selectedOptionColorScheme="brand"
        chakraStyles={chakraStyles}
      />
    ));
}
